import React from 'react'
import { Card, Spinner } from 'react-bootstrap'
import { FaDatabase, FaTags, FaImages, FaBoxes } from 'react-icons/fa'
import { StatCard, StatContent, StatIcon, StatInfo, StatsRow, StatsCol } from '../styles'

interface QuickStatsSectionProps {
  loading: boolean
  stats: {
    datasources: number
    classes: number
    images: number
    annotations: number
  }
}

const QuickStatsSection: React.FC<QuickStatsSectionProps> = ({ loading, stats }) => {
  return (
    <StatsRow className="g-3 g-lg-4">
      <StatsCol lg={3} md={6}>
        <StatCard $variant="primary">
          {loading && (
            <div className="loading-overlay">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          <Card.Body>
            <StatContent>
              <StatIcon>
                <FaDatabase />
              </StatIcon>
              <StatInfo>
                <h3>{stats.datasources}</h3>
                <p>Datasets</p>
              </StatInfo>
            </StatContent>
          </Card.Body>
        </StatCard>
      </StatsCol>

      <StatsCol lg={3} md={6}>
        <StatCard $variant="info">
          {loading && (
            <div className="loading-overlay">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          <Card.Body>
            <StatContent>
              <StatIcon>
                <FaTags />
              </StatIcon>
              <StatInfo>
                <h3>{stats.classes}</h3>
                <p>Classes</p>
              </StatInfo>
            </StatContent>
          </Card.Body>
        </StatCard>
      </StatsCol>

      <StatsCol lg={3} md={6}>
        <StatCard $variant="success">
          {loading && (
            <div className="loading-overlay">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          <Card.Body>
            <StatContent>
              <StatIcon>
                <FaImages />
              </StatIcon>
              <StatInfo>
                <h3>{stats.images}</h3>
                <p>Images</p>
              </StatInfo>
            </StatContent>
          </Card.Body>
        </StatCard>
      </StatsCol>

      <StatsCol lg={3} md={6}>
        <StatCard $variant="warning">
          {loading && (
            <div className="loading-overlay">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          <Card.Body>
            <StatContent>
              <StatIcon>
                <FaBoxes />
              </StatIcon>
              <StatInfo>
                <h3>{stats.annotations}</h3>
                <p>Annotations</p>
              </StatInfo>
            </StatContent>
          </Card.Body>
        </StatCard>
      </StatsCol>
    </StatsRow>
  )
}

export default QuickStatsSection
